import * as dayjs from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/sv';
import 'dayjs/locale/es';
import 'dayjs/locale/nb';

const setDayjsLocale = (locale) => {
  if (['en', 'sv', 'es', 'nb'].includes(locale)) {
    dayjs.locale(locale);
  } else {
    dayjs.locale('en'); 
  }
};

export default setDayjsLocale;
